export const COMPANY_NAME = "Lion Heart Clinical Research LLC";
export const COMPANY_SHORT = "Lion Heart Clinical Research";
export const COMPANY_INITIALS = "LHC";
export const COMPANY_ADDRESS_FULL = "27063 Fairway Ln, Stevenson Ranch, CA 91381";
export const COMPANY_LOCATION = "Stevenson Ranch, CA";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=27063%20Fairway%20Ln%2C%20Stevenson%20Ranch%2C%20CA%2091381";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Organization", "value": "Limited liability company" },
  { "label": "Filed", "value": "May 2025" },
  { "label": "Location", "value": "Stevenson Ranch, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Lion Heart Clinical Research LLC" },
  { "label": "Principal office", "value": "Stevenson Ranch, CA" },
  { "label": "Address", "value": "27063 Fairway Ln, Stevenson Ranch, CA 91381" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Public profile", "body": "A concise directory profile built from public filing information." },
  { "icon": "✦", "title": "Principal office", "body": "The listed principal-office address is provided for public correspondence and directory reference." },
  { "icon": "✿", "title": "California LLC", "body": "Organized as a California limited liability company in May 2025." },
  { "icon": "❍", "title": "Respectful privacy", "body": "This profile intentionally omits personal and sensitive registry details." },
];
